module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.before))]), _vm._v(" "), (_vm.data.val.split(',').length === 1) ? _c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.data.val.length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val[index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val[index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  }), 0) : _c('div', {
    staticClass: "numbers"
  }, [_vm._l((_vm.data.val.split(',')[0].length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val.split(',')[0][index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val.split(',')[0][index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  }), _vm._v(" "), _c('span', {
    staticClass: "comma"
  }, [_vm._v(",")]), _vm._v(" "), _vm._l((_vm.data.val.split(',')[1].length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val.split(',')[1][index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val.split(',')[1][index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  })], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.after))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e6c4baa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Counter.vue
// module id = 289
// module chunks = 0